import { throwError as observableThrowError, forkJoin as observableForkJoin, Observable, of } from 'rxjs';
import { catchError, delay, switchMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config/config.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../display/display.service';
import { NoteService } from '../note/note.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import _ from 'lodash';
import { TableFilterService } from '../table-filter/table-filter.service';
import { EnvService } from '../../../config/env.service';
declare global {
	interface Navigator {
	 msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void
	 msSaveBlob?: (blob: any, fileName?: string) => boolean
	}
  }
@Injectable()
export class CommsService {
	token;
	persona = '';
	nonCallErrorCode = '9999';
	nonCall;
	timeout = 30;
	cookies = {};
	// @Output() nonCall: EventEmitter<any> = new EventEmitter();


	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private dataService: DataService,
		private displayService: DisplayService,
		private noteService: NoteService,
		private injector: Injector,
		private cookieService: CookieService,
		private tableFilterService: TableFilterService,
		private env :EnvService
	) {
		// nonCall is used when the access is not allowed according to environments/endpoints.ts
		// is simulates an API call and can return the following error response without having to make an HTTP call
		this.nonCall = new Observable((call) => {
			const err = {
				error: {
					message: 'Unauthorized Access',
					code: this.nonCallErrorCode
				}
			};
			call.error(err);
		});
	}

	getTrimmedPayload(config, newPayload, originalPayload) {
		// TODO: TRIM PAYLOAD ONCE NEW CONFIG.CSV IS AVAILABLE
		const trimmedPayload = newPayload;
		return trimmedPayload;
	}

	canAccess(access) {
		const self = this;
		let canAccess = false;
		access.forEach(function (d, i) {
			if (self.persona === d) {
				canAccess = true;
			}
		});
		return canAccess;
	}

	handleAPIError(method, err, autoClean = false) {
		const defaultErr = 'An unexpected error has occurred.  Please try again later or contact https://ibm.service-now.com/Procurement@IBM';
		if (method) {
			method += ' Error: ';
		}
		try {
			let body = err.error;
			if (typeof body !== 'object') {
				body = JSON.parse(err.error);
			}
			const message = body.message;
			const detail = body.detail;
			console.log('API ERROR', err, body, message, detail);
			let displayDetail = '';
			if (typeof detail === 'string') {
				displayDetail = ' - ' + detail;
			}

			if (body.code === '1111INV') {  // invalid token error
				this.logoutAndRedirectToLogin();
				this.noteService.displayError('Session Expired. Please Log In again', true);
			} else if (body.code !== this.nonCallErrorCode) {
				// check if the API didn't respond with anything to log
				if ((message === undefined || message === '') && (displayDetail === '' || displayDetail === ' - ')) {
					throw 'Response body does not contain error details';
				}
				this.noteService.displayError(method + message + displayDetail, autoClean);
			}
		} catch (e) {
			console.error('ERROR PROCESSING ERROR', e, err);
			this.noteService.displayError(method + defaultErr, autoClean);
		}
	}

	getPartialError(res) {
		const jsonRes = res;
		const errorData = jsonRes[this.configService.errorDataProp][this.configService.detailDataProp];
		console.log('GOT PARTIAL ERROR', res, jsonRes, errorData);
		return errorData;
	}

	getPartialSuccess(res) {
		const jsonRes = res;
		const successData = jsonRes[this.configService.successDataProp][this.configService.detailDataProp];
		console.log('GOT PARTIAL SUCCESS', res, jsonRes, successData);
		return successData;
	}

	getSuccessData(res) {
		const jsonRes = res;
		// const detail = this.configService.detailDataProp;
		// const records = this.configService.recordsDataProp;
		// const successData = jsonRes[detail][records] !== undefined ? jsonRes[detail][records] : jsonRes[detail];
		const detail = this.configService.detailDataProp;
		const successData = jsonRes[detail];
		return successData;
	}

	getSuccessValue(res) {
		console.log('GET SUCCESS VALUE', res);
		const detail = this.configService.detailDataProp;
		const value = this.configService.detailValueProp;
		let successData = null;
		if (res[detail] && res[detail][value]) {
			successData = JSON.parse(res[detail][value]);
		}
		return successData;
	}

	getSuccessCount(res) {
		let successCount;
		try {
			const jsonRes = res;
			const count = this.configService.countDataProp;
			successCount = jsonRes[count];
			return successCount;
		} catch (e) {
			// backend doesnt support pagination for the response with partial success
			if (_.isArray(res)) {
				successCount = res.length;
			}
			return successCount;
		}
	}

	/**
	 * Universal document post call
	 */
	postDoc(formData, endpoint, addString = '') {
		const self = this;
		if (this.canAccess(endpoint.access)) {
			const headers = new HttpHeaders({
				'x-access-token': self.token,
				'Authorization': 'Bearer ' + self.token
			});
			console.log('POST ENDPOINT: ', endpoint);
			console.log('POST DATA: ', formData);
			return this.http.post(this.env.getApiRoot() + endpoint.path + addString, formData, {headers});
		} else {
			console.log('NO ACCESS', endpoint);
			return self.nonCall;
		}
	}

	/**
	 * Universal document get call
	 */
	getDoc(endpoint, addString = '') {
		const self = this;
		if (this.canAccess(endpoint.access)) {
			const headers = new HttpHeaders({
				'x-access-token': self.token,
				'Authorization': 'Bearer ' + self.token
			});
			console.log('GET ENDPOINT: ', endpoint);
			const url = this.env.getApiRoot() + endpoint.path + addString;
			return this.http.get(url, {headers, responseType: 'arraybuffer'}).pipe(
				catchError(error => this.errorHandlerForGetDoc(error, url)));
		} else {
			console.log('NO ACCESS', endpoint);
			return self.nonCall;
		}
	}

	/**
	 * Universal API post call
	 */
	postCall(body, endpoint, addString?, host?, customHTTPProps = {}) {

		console.log('POST CALL TOKEN: ', this.token);

		if (this.canAccess(endpoint.access)) {

			let headers = new HttpHeaders({
				'Content-Type': 'application/json'
			});

			if (this.token) {
				headers = headers.append('x-access-token', this.token);
				headers = headers.append('Authorization', 'Bearer ' + this.token);
			}

			const addEnd = addString === undefined ? '' : addString;
			const root = host === undefined ? this.env.getApiRoot() : host;
			const url = root + endpoint.path + addEnd;
			console.log('POST URL: ', url);

			return this.http.post<any>(url, body, { headers, ...customHTTPProps}).pipe(
				catchError(error => this.errorHandler(error, url, 'POST', body)));
		} else {
			console.log('POST NO ACCESS', endpoint);
			return this.nonCall;
		}
	}

	/**
	 * Universal API put call
	 */
	putCall(body, endpoint, addString?, host?) {

		if (this.canAccess(endpoint.access)) {

			let headers = new HttpHeaders({
				'Content-Type': 'application/json'
			});

			if (this.token) {
				headers = headers.append('x-access-token', this.token);
				headers = headers.append('Authorization', 'Bearer ' + this.token);
			}

			const addEnd = addString === undefined ? '' : addString;
			const root = host === undefined ? this.env.getApiRoot() : host;
			const url = root + endpoint.path + addEnd;
			console.log('PUT URL: ', url);

			return this.http.put<any>(url, body, { headers }).pipe(
				catchError(error => this.errorHandler(error, url, 'PUT', body)));
		} else {
			console.log('PUT NO ACCESS', endpoint);
			return this.nonCall;
		}
	}

	/**
	 * Universal API get call
	 */
	getCall(endpoint, addString?, host?) {

		if (this.canAccess(endpoint.access)) {

			let headers = new HttpHeaders({
				'Content-Type': 'application/json'
			});

			if (this.token) {
				headers = headers.append('x-access-token', this.token);
				headers = headers.append('Authorization', 'Bearer ' + this.token);
			}

			const addEnd = addString === undefined ? '' : addString;
			const root = host === undefined ? this.env.getApiRoot() : host;
			const url = root + endpoint.path + addEnd;
			console.log('GET URL: ', url);

			return this.http.get<any>(url, { headers }).pipe(
				catchError(error => this.errorHandler(error, url, 'GET')));

		} else {
			console.log('GET NO ACCESS', endpoint);
			return this.nonCall;
		}
	}

	/**
	 * Universal API delete call
	 */
	deleteCall(body, endpoint, addString?, host?) {

		if (this.canAccess(endpoint.access)) {
			let headers = new HttpHeaders({
				'Content-Type': 'application/json'
			});

			if (this.token) {
				headers = headers.append('x-access-token', this.token);
				headers = headers.append('Authorization', 'Bearer ' + this.token);
			}
			const httpOptions = {
				headers: headers,
				body: body
			};
			const addEnd = addString === undefined ? '' : addString;
			const root = host === undefined ? this.env.getApiRoot() : host;
			const url = root + endpoint.path + addEnd;
			console.log('Add String: ', addEnd);
			console.log('Root: ', root);
			console.log('DELETE URL: ', url);
			return this.http.delete<any>(url, httpOptions).pipe(
				catchError(error => this.errorHandler(error, url, 'DELETE', body)));
		} else {
			console.log('DELETE NO ACCESS', endpoint);
			return this.nonCall;
		}
	}

	// SWITCHES
	smartContract(data, prop) {
		const self = this;
		switch (prop) {
			case 'hoursrestriction':
				return self.sendHoursRestriction(data);
			case 'poroledelegation':
				return self.sendPODelegation(data);
			case 'poassigntra':
				return self.sendPODelegation(data);
			case 'contractorassigntra':
			case 'dtvscheduleupdate':
				return self.sendContractorDelegation(data);
			case 'approvetimesheet':
				return self.sendTimesheets(data);
			case 'migratetimesheet':
				return self.migrateTimesheets(data);
			case 'forcereconciliation':
				return self.forceReconciliation(data);
			case 'pomigrate':
				return self.migrateCancelledPO(data);
			case 'poarchive':
				return self.archivePOs(data);
			case 'porestore':
				return self.restorePOs(data);
			case 'contractorarchive':
				return self.archiveContractors(data);
			case 'contractorrestore':
				return self.restoreContractors(data);
			case 'invoicearchive':	// invoice reconciliations
				return self.archiveInvoiceReconciliations(data);
			case 'invoicerestore':	// invoice reconciliations
				return self.restoreInvoiceReconciliations(data);
			case 'supplierinvoicereject':
				return self.rejectSupplierInvoices(data);
		}
	}

	approveSmartContract(data, prop) {
		const self = this;
		switch (prop) {
			case 'adjustedrate':
				return self.approveRate(data);
		}
	}

	deleteSmartContract(data, prop) {
		const self = this;
		switch (prop) {
			case 'hoursrestriction':
				return self.deleteHoursRestriction(data);
		}
	}

	updateSmartContract(data, prop) {
		const self = this;
		switch (prop) {
			case 'hoursrestriction':
				return self.updateHoursRestriction(data);
		}
	}

	// List calls
	// Sparating from other API calls as these are in flux
	// and postentially changing for consistency in the near future

	getContractorList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;

			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		let body = {
			status: data.prop,
			category: 'unarchive'
		};

		if (data.prop === 'archive') {
			body = {
				status: 'all',
				category: data.prop
			};
		}
		if (data.prop !== 'cancellation') {
			body['cancellation'] = false;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		if (data[this.configService.buyercontractoremail]) {
			body[this.configService.buyercontractoremail] = data[this.configService.buyercontractoremail];
		}
		return this.postCall(body, this.env.getEndPoints().contractorListEnd, urlParams);
	}

	downloadAllContractors(data) {
		let body = {
			status: data.prop,
			category: 'unarchive'
		};
		if (data.prop === 'archive') {
			body = {
				status: 'all',
				category: data.prop
			};
		}
		if (data.prop !== 'cancellation') {
			body['cancellation'] = false;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().downloadContractorsEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getPOContractorList(poNumber, prop) {
		const body = {
			ponumber: poNumber,
			status: prop
		};
		return this.postCall(body, this.env.getEndPoints().contractorListEnd);
	}

	// getFilterParams() {
	// 	let filterParams = '';
	// 	const connector = ',';
	// 	if(this.dataService.userSettings.countryFilters.length > 0){
	// 		console.log('TOTAL COUNTRY FILTERS', this.dataService.userSettings.countryFilters.length);
	// 		let filterValue = '';
	// 		const self = this;
	// 		this.dataService.userSettings.countryFilters.forEach(function (d, i) {
	// 			if (d.subscribed) {
	// 				console.log('GOT COUNTRY FILTER PARAM', d.countrycode);
	// 				filterValue = filterValue + d.countrycode + connector;
	// 			}
	// 		});
	// 		if (filterValue !== '') {
	// 			filterValue = filterValue.slice(0, -1);
	// 			filterParams = 'countrycode=' + filterValue;
	// 		}
	// 	}

	// 	if(this.dataService.userSettings.divisionFilters.length > 0){
	// 		console.log('TOTAL DIVISION FILTERS', this.dataService.userSettings.divisionFilters.length);
	// 		let filterValue = '';
	// 		const self = this;
	// 		this.dataService.userSettings.divisionFilters.forEach(function (d, i) {
	// 			if (d.subscribed) {
	// 				console.log('GOT DIVISION FILTER PARAM', d.divisioncode);
	// 				filterValue = filterValue + d.divisioncode + connector;
	// 			}
	// 		});
	// 		if (filterValue !== '') {
	// 			filterValue = filterValue.slice(0, -1);
	// 			if(filterParams !== '' ){
	// 				filterParams =  filterParams + '&';
	// 			}
	// 			filterParams = filterParams + 'divisionode=' + filterValue;
	// 		}
	// 	}
	// 	console.log('GOT FILTER PARAMS', filterParams);
	// 	return filterParams;
	// }

	getUserCountries() {
		let userCountries = '';
		const connector = ',';
		if (this.dataService.userSettings.countryFilters.length > 0) {
			console.log('TOTAL COUNTRY FILTERS', this.dataService.userSettings.countryFilters.length);
			let filterValue = '';
			this.dataService.userSettings.countryFilters.forEach((d, i) => {
				if (d.subscribed) {
					console.log('GOT COUNTRY FILTER PARAM', d.countrycode);
					const countrycode = d.countrycode === this.dataService.emptyLabel ? '' : d.countrycode;
					filterValue = filterValue + countrycode + connector;
				}
			});
			if (filterValue !== '') {
				filterValue = filterValue.slice(0, -1);
				userCountries = filterValue;
			}
		}
		console.log('GOT USER COUNTRIES', userCountries);
		return userCountries;
	}

	getUserDivisions() {
		let userDivisions = '';
		const connector = ',';
		if (this.dataService.userSettings.divisionFilters.length > 0) {
			console.log('TOTAL DIVISION FILTERS', this.dataService.userSettings.divisionFilters.length);
			let filterValue = '';
			this.dataService.userSettings.divisionFilters.forEach((d, i) => {
				if (d.subscribed) {
					const divisioncode = d.divisioncode === this.dataService.emptyLabel ? '' : d.divisioncode;
					console.log('GOT DIVISION FILTER PARAM', d.divisioncode);
					filterValue = filterValue + divisioncode + connector;
				}
			});
			if (filterValue !== '') {
				filterValue = filterValue.slice(0, -1);
				userDivisions = filterValue;
			}
		}
		console.log('GOT USER DIVISIONS', userDivisions);
		return userDivisions;
	}

	getUserCostCenters() {
		let userCostCenters = '';
		const connector = ',';
		if (this.dataService.userSettings.costCenterFilters.length > 0) {
			console.log('TOTAL COSTCENTER FILTERS', this.dataService.userSettings.costCenterFilters.length);
			let filterValue = '';
			this.dataService.userSettings.costCenterFilters.forEach((d, i) => {
				if (d.subscribed) {
					const costcenter = d.costcenter === this.dataService.emptyLabel ? '' : d.costcenter;
					console.log('GOT COSTCENTER FILTER PARAM', d.costcenter);
					filterValue = filterValue + costcenter + connector;
				}
			});
			if (filterValue !== '') {
				filterValue = filterValue.slice(0, -1);
				userCostCenters = filterValue;
			}
		}
		console.log('GOT USER COSTCENTERS', userCostCenters);
		return userCostCenters;
	}

	getPOList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;

			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		// const filterParams = this.getFilterParams();
		// if(filterParams !== '') {
		// 	if(urlParams === '') {
		// 		urlParams = '?'
		// 	} else {
		// 		urlParams = urlParams + '&';
		// 	}
		// 	urlParams = urlParams + filterParams;
		// }

		const body = {};
		if (data.prop === 'nocontractors') {
			body['nocontractors'] = true;
		} else {
			body['category'] = data.prop;
		}

		if (data.prop !== 'cancellation') {
			body['cancellation'] = false;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().poListEnd, urlParams);
	}

	downloadPOsForTab(data) {
		const body = {};
		if (data.prop === 'nocontractors') {
			body['nocontractors'] = true;
		} else {
			body['category'] = data.prop;
		}

		if (data.prop !== 'cancellation') {
			body['cancellation'] = false;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().downloadPOsEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getPOListForMigration(data) {
		return this.postCall(data, this.env.getEndPoints().migrationCancellationList);
	}

	/**
	 * Gets timesheet data for Timesheets table page
	 */
	getTimesheetList(data, loadAll = false, nonBillableCodes = undefined) {
		let urlParams = '';
		if (!loadAll) {
			let pageSize = this.configService.pageSize;
			if (data['pageSize']) {
				pageSize = data['pageSize'];
			}
			const offset = pageSize * data.page;

			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			} else {
				sortQuery = '&sortBy=enddate&descending=true';
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		const body = {};
		if (data.prop !== 'all') {
			body['status'] = data.prop;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		// use selected country first, or user countries from user settings second if not provided
		const userSelectedCountry = data['countrycode'];
		const userCountries = this.getUserCountries();
		if (userSelectedCountry) {
			body[this.configService.countryCodeProp] = userSelectedCountry;
		} else if (userCountries !== '' && body[this.configService.countryCodeProp] === undefined) {
			body[this.configService.countryCodeProp] = userCountries;
		}

		this.addUserSettingsToBody(body);

		// if nonBillableCodes are already passed in, then just return them using an "of" observable
		let nonBillableCodesObservable = this.getNonBillableCodes();
		if (nonBillableCodes) {
			nonBillableCodesObservable = of({ [this.configService.detailDataProp]: {ilccodes: nonBillableCodes} });
		}

		// retrieve timesheets and nonbillable codes at the same time
		return observableForkJoin({
			timesheets: this.postCall(body, this.env.getEndPoints().timesheetsEnd, urlParams),
			nonbillablecodes: nonBillableCodesObservable
		});
	}

	downloadAllTimesheets(data) {
		const body = {};
		if (data.prop !== 'all') {
			body['status'] = data.prop;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		if (data[this.configService.countryCodeProp]) {
			body[this.configService.countryCodeProp] = data[this.configService.countryCodeProp];
		}

		this.addUserSettingsToBody(body);
		
		return this.postCall(body, this.env.getEndPoints().downloadTimesheetsEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	/**
	 * Gets timesheet data for timesheet list on single Contractor page
	 */
	getContractorTimesheetList(data, poNumber, contractorId, supplierId, startdate, enddate, nonBillableCodes = undefined) {
		const pageSize = this.configService.pageSize;
		const offset = pageSize * data.page;
		const body = {
			ponumber: poNumber,
			poconnector: contractorId,
			supplierid: supplierId,
			startdate: startdate,
			enddate: enddate
		};
		if (data.prop !== 'all') {
			body['status'] = data.prop;
		}

		// if nonBillableCodes are already passed in, then just return them using an "of" observable
		let nonBillableCodesObservable = this.getNonBillableCodes();
		if (nonBillableCodes) {
			nonBillableCodesObservable = of({ [this.configService.detailDataProp]: {ilccodes: nonBillableCodes} });
		}

		// retrieve timesheets and nonbillable codes at the same time
		return observableForkJoin({
			timesheets: this.postCall(body, this.env.getEndPoints().timesheetsEnd, '?skip=' + offset + '&limit=' + pageSize),
			nonbillablecodes: nonBillableCodesObservable
		});
	}

	getInvoiceList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;
			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		const body = {};
		body['inactive'] = false;
		if (data.prop === 'inactive') {
			body['inactive'] = true;
		}
		if (data.prop !== 'all' && data.prop !== 'inactive') {
			body['cleartoinvoice'] = data.prop;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		if (data.type === 'BDW') {
			body['type'] = data.type;
		}

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().invoiceListEnd, urlParams);
	}

	downloadAllInvoices(data) {
		const body = {};
		if (data.prop !== 'all') {
			body['status'] = data.prop;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);
		
		if (data.type === 'standard') {
			return this.postCall(body, this.env.getEndPoints().downloadInvoicesEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
		} else if (data.type === 'BDW') {
			return this.postCall(body, this.env.getEndPoints().downloadSupplierInvoicesEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
		} else if (data.type === 'BC') {
			return this.postCall(body, this.env.getEndPoints().downloadBCInvoicesEnd, undefined, this.env.getReportRoot(), {responseType: 'text'});
		}
	}

	getInvoiceReconciliation(data, needFailureReason: boolean = false) {
		if (!needFailureReason) {
			return this.postCall(data, this.env.getEndPoints().invoiceReconciliationEnd);
		} else {
			const invoiceObservable = this.postCall(data, this.env.getEndPoints().invoiceReconciliationEnd);
			const reasonsObservable = this.getCall(this.env.getEndPoints().invoiceFailureReasonsEnd);
			return observableForkJoin({
				invoice: invoiceObservable,
				failureReasons: reasonsObservable
			});
		}

	}

	updateInvoiceConmments(data) {
		return this.putCall(data, this.env.getEndPoints().invoiceCommentsUpdateEnd);
	}

	runInvoiceReconciliation(data) {
		return this.postCall(data, this.env.getEndPoints().invoiceReconcilEnd);
	}

	getSupplierInvoiceDetails(data) {
		return this.postCall(data, this.env.getEndPoints().supplierInvoiceDetailsEnd);
	}

	getBlockchainInvoiceDetails(data) {
		return this.postCall(data, this.env.getEndPoints().bcInvoiceDetailsEnd);
	}

	getSupplierInvoiceList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			let pageSize = this.configService.pageSize;
			if (data['pageSize']) {
				pageSize = data['pageSize'];
			}
			const offset = pageSize * data.page;
			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		const body = {};
		if (data.prop !== 'all' && data.prop !== 'inactive') {
			body['cleartoinvoice'] = data.prop;
		}
		if (data.prop === 'inactive') {
			body['inactive'] = true;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().supplierInvoiceListEnd, urlParams);
	}

	getBCInvoiceList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;
			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}

		const body = {};
		if (data.prop !== 'all') {
			body['cleartoinvoice'] = data.prop;
		}

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		this.addUserSettingsToBody(body);

		return this.postCall(body, this.env.getEndPoints().bcInvoiceListEnd, urlParams);
	}

	getPOInvoiceList(data, poNumber) {
		let pageSize = this.configService.pageSize;
		if (data['pageSize']) {
			pageSize = data['pageSize'];
		}
		const offset = pageSize * data.page;
		const body = {
			ponumber: poNumber
		};
		if (data.prop !== 'all') {
			body['cleartoinvoice'] = data.prop;
		}
		body['inactive'] = false;
		/*
		this.addUserSettingsToBody(body);
		*/
		return this.postCall(body, this.env.getEndPoints().invoiceListEnd, '?skip=' + offset + '&limit=' + pageSize);
	}


	// POSTS
	/*
	API call to authenticate user
	*/
	loginUser(username, password) {

		const body = {
			email: username,
			password: password
		};
		return this.postCall(body, this.env.getEndPoints().userLoginEnd);
	}

	ssoLoginUser(code, redirectURI, companyName) {
		return this.postCall({ code, redirect_uri: redirectURI, company: companyName }, this.env.getEndPoints().userSSOLoginEnd);
	}

	resetPassword(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().resetPasswordEnd);
	}

	forgotPassword(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().forgotPasswordEnd);
	}

	submitPassword(data) {

		const body = data;
		return this.postCall(body, this.env.getEndPoints().userPasswordEnd);
	}

	approveRate(data) {
		return this.postCall(data, this.env.getEndPoints().smartContractsApproveEnd);
	}

	deleteHoursRestriction(data) {
		return this.deleteCall(data, this.env.getEndPoints().hoursRestrictionDeleteEnd);
	}

	updateHoursRestriction(data) {
		return this.postCall(data, this.env.getEndPoints().hoursRestrictionEnd);
	}

	getZeroConfigs() {
		const body = {
			key: 'ZEROCONFIGURATIONS'
		};
		return this.postCall(body, this.env.getEndPoints().retrieveConfig);
	}

	getPODetails(poNumber, supplierId) {

		const body = {
			ponumber: poNumber,
			supplierid: supplierId
		};
		return this.postCall(body, this.env.getEndPoints().poDetailsEnd);
	}

	getContractorDetails(poNumber, contractorId, supplierId) {

		const body = {
			ponumber: poNumber,
			uuid: contractorId,
			supplierid: supplierId
		};
		return this.postCall(body, this.env.getEndPoints().contractorDetailsEnd);
	}

	getCalendarList(tab, data = null) {
		let body = {};
		if (data) {
			body = data;
		}
		return this.postCall(body, this.env.getEndPoints().invoiceCalListEnd);
	}

	getScheduleDTVs(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;

			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}
		return this.getCall(this.env.getEndPoints().scheduledDTVs, urlParams);
	}

	sendPrivacyAgreement() {
		const body = {
			isagreedforprivacy: true
		};
		return this.postCall(body, this.env.getEndPoints().privacyAgreement);
	}

	removeInvoiceCal(data) {

		const body = {
			id: data.id
		};
		return this.deleteCall(body, this.env.getEndPoints().invoiceCalDeleteEnd);
	}

	approveContractor(poNumber, contractorId, supplierId, approvalstatus) {

		const body = {
			ponumber: poNumber,
			uuid: contractorId,
			supplierid: supplierId,
			rejectioncomment: '',
			approvalstatus: approvalstatus
		};
		return this.postCall(body, this.env.getEndPoints().approveContractorEnd);
	}

	warrantContractor(body) {
		return this.postCall(body, this.env.getEndPoints().warrantContractorEnd);
	}

	sendContractor(contractorData) {
		if (!contractorData[this.configService.contractorILCProp] && contractorData[this.configService.ilcSerialNumProp]) {
			contractorData[this.configService.ilcSerialNumProp] = '';
		}
		const body = contractorData;
		return this.postCall(body, this.env.getEndPoints().contractorEnd);
	}

	sendPOInvoiceCalendar(poNumber, supplierId, newCalendarId) {

		const body = {
			ponumber: poNumber,
			supplierid: supplierId,
			calendarid: newCalendarId
		};
		return this.postCall(body, this.env.getEndPoints().poCalendarEnd);
	}

	mergeContractor(mergeData) {

		const body = mergeData;
		return this.postCall(body, this.env.getEndPoints().mergeContractorEnd);
	}

	sendUserEdits(userData) {

		const body = userData;
		return this.postCall(body, this.env.getEndPoints().userEnd);
	}

	sendAccount(account) {

		const body = account;
		return this.postCall(body, this.env.getEndPoints().accountEnd);
	}

	migrateTimesheets(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().migrateTimesheetsEnd);
	}

	migrateCancelledPO(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().migrateCancelledPOEnd);
	}

	sendTimesheet(timesheet) {
		const body = timesheet;
		return this.postCall(body, this.env.getEndPoints().timesheetEnd);
	}

	sendTimesheetApproval(approval) {
		const body = approval;
		return this.postCall(body, this.env.getEndPoints().timesheetApprovalEnd);
	}

	archiveTimesheet(data) {
		return this.postCall(data, this.env.getEndPoints().timesheetArchiveEnd);
	}

	restoreTimesheet(data) {
		return this.postCall(data, this.env.getEndPoints().timesheetRestoreEnd);
	}

	sendAccounts(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().assignAccountsEnd);
	}

	sendPODelegation(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().poDelegationEnd);
	}

	sendContractorDelegation(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().contractorDelegationEnd);
	}

	sendTimesheets(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().timesheetsApprovalEnd);
	}

	sendSOW(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().sowEnd);
	}

	sendRate(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().rateEnd);
	}

	sendTerms(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().termsEnd);
	}

	uploadExpenseDoc(formData) {
		return this.postDoc(formData, this.env.getEndPoints().documentEnd);
	}

	getExpenseDocs(entityId, supplierId) {
		const body = {
			entityid: entityId,
			supplierid: supplierId
		};
		return this.postCall(body, this.env.getEndPoints().documentsEnd);
	}

	attachInvoiceNumber(data) {
		return this.postCall(data, this.env.getEndPoints().invoiceEnd);
	}

	updateInvoiceBillingDates(data) {
		return this.postCall(data, this.env.getEndPoints().invoiceEnd);
	}

	saveContractorAddons() {
		return this.postCall(this.dataService.contractorAddonsEdited, this.env.getEndPoints().addonsContractorEnd);
	}

	deleteContractorAddon(fieldId) {
		const body = [fieldId];
		return this.deleteCall(body, this.env.getEndPoints().addonsContractorDeleteEnd);
	}

	getAllConfig() {
		return this.postCall({}, this.env.getEndPoints().getAllConfig);
	}

	getLineItem(key, supplierId = '', countrycode = this.configService.countryCodes.US) {
		const data = { 'key': key };
		if (supplierId) {
			data['supplierid'] = supplierId;
		}
		// backend needs country code to get it in the format UI needs. so as of right now we are 
		// adding country code defaults to US
		if (key === 'DEFAULTLINEITEMS') {
			data['countrycode'] = countrycode;
		}
		return this.postCall(data, this.env.getEndPoints().retrieveConfig);
	}

	getLineItems(key1, key2, supplierId = '', countrycode = this.configService.countryCodes.US) {
		const data1 = { 'key': key1 };
		const data2 = { 'key': key2 };
		if (supplierId) {
			data1['supplierid'] = supplierId;
			data2['supplierid'] = supplierId;
		}
		
		// backend needs country code to get it in the format UI needs. so as of right now we are 
		// adding country code defaults to US
		if (key1 === 'DEFAULTLINEITEMS') {
			data1['countrycode'] = countrycode;
		}
		if (key2 === 'DEFAULTLINEITEMS') {
			data2['countrycode'] = countrycode;
		}

		const url1 = this.postCall(data1, this.env.getEndPoints().retrieveConfig);
		const url2 = this.postCall(data2, this.env.getEndPoints().retrieveConfig);
		return observableForkJoin([url1, url2]);
	}

	retrieveConfig(key) {
		return this.postCall({ 'key': key }, this.env.getEndPoints().retrieveConfig);
	}

	recordConfig(body) {
		return this.putCall(body, this.env.getEndPoints().recordConfig);
	}
	findAccounts(account, contractorId, startDate, deepSearch = false) {
		const body = {};
		body['accountid'] = account['accountid'];
		body['workitemid'] = account['workitemid'];
		body['workitemdescription'] = account['workitemdescription'];
		body['activitycode'] = account['activitycode'];
		body['activitydescription'] = account['activitydescription'];
		body['billcode'] = account['billcode'];
		body['serialnumber'] = contractorId;
		body['startdate'] = startDate;
		if (deepSearch) {
			body['search'] = 'origin';
		}
		return this.postCall(body, this.env.getEndPoints().ilcAccountsEnd);
	}

	// PUTS

	createUsers(data) {
		const body = data;
		return this.putCall(body, this.env.getEndPoints().createusers);
	}

	recordTIME_ESC_CONFIG(value) {
		const body = {
			'key': 'TIME_ESC_CONFIG',
			'type': 'ESCCUTOFF',
			'value': value
		};
		return this.putCall(body, this.env.getEndPoints().recordConfig);
	}

	recordTIME_ESC_NOTIFTY(day) {
		const body = {
			'key': 'TIME_ESC_NOTIFTY',
			'type': 'ESCNOTIFY',
			'value': day
		};
		return this.putCall(body, this.env.getEndPoints().recordConfig);
	}

	saveLineItems(lineItems, key) {
		const body = {
			'key': key,
			'type': 'ITEM',
			'value': lineItems
		};
		return this.putCall(body, this.env.getEndPoints().recordConfig);
	}

	sendInvoiceCal(data) {
		return this.putCall(data, this.env.getEndPoints().invoiceCalEnd);
	}

	sendHoursRestriction(data) {
		const body = data;
		return this.putCall(body, this.env.getEndPoints().hoursRestrictionEnd);
	}

	sendPO(poData) {
		const body = poData;
		// return this.putCall(body, this.env.poEnd);
		// const self = this;
		// const bodyString = body;
		// const headers = new Headers({
		// 	'Content-Type': 'application/json',
		// 	'x-access-token': self.token,
		// 	'Authorization': 'Bearer ' + self.token
		// });
		// const options = new RequestOptions({ headers: headers });
		// console.log('PUT BODY: ' + bodyString);
		// return this.http.put(this.env.apiRoot + this.env.endpoints.poEnd.path, bodyString, options).pipe(map(res => res),
		// 	catchError(error => this.errorHandlerForSendPOAndInvoice(error, this.env.apiRoot + this.env.endpoints.poEnd.path, bodyString)),);

		return this.putCall(body, this.env.getEndPoints().poEnd);

	}

	sendInvoice(invoiceData) {
		const body = invoiceData;
		// const self = this;
		// const bodyString = body;
		// const headers = new Headers({
		// 	'Content-Type': 'application/json',
		// 	'x-access-token': self.token,
		// 	'Authorization': 'Bearer ' + self.token
		// });
		// const options = new RequestOptions({ headers: headers });
		// console.log('PUT BODY: ' + bodyString);
		// return this.http.put(this.env.apiRoot + this.env.endpoints.invoiceSubmitEnd.path, bodyString, options).pipe(
		// 	map(res => res),
		// 	catchError(error => this.errorHandlerForSendPOAndInvoice(error, this.env.apiRoot + this.env.apiRoot + this.env.endpoints.invoiceSubmitEnd.path, bodyString)),);

		return this.putCall(body, this.env.getEndPoints().invoiceSubmitEnd);
	}

	sendNewContractor(contractorData) {
		if (!contractorData[this.configService.contractorILCProp] && contractorData[this.configService.ilcSerialNumProp]) {
			contractorData[this.configService.ilcSerialNumProp] = '';
		}

		const body = contractorData;
		return this.putCall(body, this.env.getEndPoints().contractorEnd);
	}

	getTimesheet(poNumber, contractorId, supcontId, supplierId, date, checkDuplicate = false, copyclaimcodes = null) {

		const body = {
			ponumber: poNumber,
			uuid: contractorId,
			suppliercontractorid: supcontId,
			supplierid: supplierId,
			startdate: date,
			enddate: date,
			checkduplicate: checkDuplicate
		};

		if (copyclaimcodes) {
			body['copyclaimcodes'] = copyclaimcodes;
		}
		return this.putCall(body, this.env.getEndPoints().timesheetEnd);
	}

	sendNewAccount(account) {

		const body = account;
		return this.putCall(body, this.env.getEndPoints().accountEnd);
	}

	registerUser(username, email, org) {
		const body = {
			enrollmentid: username,
			email: email,
			org: org
		};
		return this.putCall(body, this.env.getEndPoints().registeruser);
	}

	sendReasonCode(timesheetId, reasonCode) {
		const body = {
			id: timesheetId,
			reasoncode: reasonCode
		};
		return this.putCall(body, this.env.getEndPoints().timesheetReasonEnd);
	}

	sendContractorRecords(data) {
		const body = data;
		return this.putCall(body, this.env.getEndPoints().contractorBulk);
	}

	// DELETES

	removeAccount(accountId) {

		return this.deleteCall(null, this.env.getEndPoints().accountEnd, '/' + accountId);
	}

	removeFile(id) {
		return this.deleteCall(null, this.env.getEndPoints().documentEnd, '/' + id + '/' + this.configService.supplierId);
	}

	// GETS

	/*
	API call to query smart contract list
	*/
	getSmartContractList(data, loadAll = false) {
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;
			urlParams = '?skip=' + offset + '&limit=' + pageSize;
		}
		return this.getCall(this.env.getEndPoints().smartContractsListEnd, urlParams);
	}

	/*
	API call to query pending smart contract list
	*/
	getPendingSmartContractList(data) {
		return this.getCall(this.env.getEndPoints().pendingSmartContractsListEnd);
	}

	/*
	API call to get single account structure
	*/
	getAccount(accountId) {
		return this.getCall(this.env.getEndPoints().accountEnd, '/' + accountId);
	}

	/*
	API call to get all accounts
	*/
	getAccounts(ponumber) {
		let parm = '';
		if (ponumber) {
			parm = '?ponumber=' + ponumber;
		}
		return this.getCall(this.env.getEndPoints().accountsEnd, parm);
	}

	getAllBankHolidays(countrycode) {
		let parm = '';
		if (countrycode) {
			parm = '?countrycode=' + countrycode;
		}
		return this.getCall(this.env.getEndPoints().bankHolidaysEnd, parm);
	}


	/*
	API call to query pending actions list
	*/
	getpendingActions() {
		return this.getCall(this.env.getEndPoints().pendingActionsEnd);
	}

	getQueueItems() {
		return this.getCall(this.env.getEndPoints().queueItemsEnd, '', this.env.getSocketRoot);
	}

	/**
	 * API call to query quantity types
	 */
	getQuantityTypes(countrycode) {
		let urlParams = '';
		if(countrycode) {
			urlParams = '?countrycode=' + countrycode;
		}
		return this.getCall(this.env.getEndPoints().quantityTypesEnd, urlParams);
	}

	getPendingUserRequests() {
		return this.getCall(this.env.getEndPoints().pendingUserRequests);
	}

	getUsers(data, loadAll = false) {
		console.log('GET USERS', data);
		let urlParams = '';
		if (!loadAll) {
			const pageSize = this.configService.pageSize;
			const offset = pageSize * data.page;

			let sortQuery = '';
			if (data.sortParam !== '') {
				sortQuery = '&sortBy=' + data.sortParam;
			}

			let dirQuery = '';
			if (data.sortDir !== '') {
				const desc = data.sortDir === 'desc';
				dirQuery = '&descending=' + desc;
			}

			urlParams = '?skip=' + offset + '&limit=' + pageSize + sortQuery + dirQuery;
		}
		const body = {};
		if (data.prop !== 'all') {
			body['status'] = data.prop;
		}
		body['org'] = data.org;
		const self = this;

		this.tableFilterService.applyFilterToBody(data.tableFilters, body);

		return this.postCall(body, this.env.getEndPoints().users, urlParams);
	}

	getUsersByPersona(role) {
		const body = {
			role: role
		};
		return this.postCall(body, this.env.getEndPoints().users);
	}

	revokeUsers(data) {
		return this.postCall(data, this.env.getEndPoints().revokeusers);
	}

	revalidateUsers(data) {
		return this.postCall(data, this.env.getEndPoints().revalidateusers);
	}

	/**
	 * API call to authenticate a specific role
	 */
	loginRole(role) {
		return this.getCall(this.env.getEndPoints().authenticationRoleEnd, '?role=' + role);
	}

	/**
	 * API call to query user keys
	 */
	getUserKeys(cancelled?) {
		let parms = '';
		if (cancelled !== null && cancelled !== undefined) {
			parms = '?cancellation=' + cancelled;
		}
		return this.getCall(this.env.getEndPoints().userKeysEnd, parms);
	}

	getUserEmail() {
		return this.getCall(this.env.getEndPoints().tokenInfoEnd);
	}

	/**
	 * API call to load document
	 */
	loadFile(id) {
		return this.getDoc(this.env.getEndPoints().documentEnd, '/' + id);
	}

	getILCReasonCodes() {
		return this.getCall(this.env.getEndPoints().ilcReasonCodesEnd);
	}

	getContractorAddons() {
		return this.getCall(this.env.getEndPoints().addonsContractorEnd);
	}

	archivePOs(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().archivePOsEnd);
	}

	archiveInvoices(data, inactive) {
		const body = {
			inactive: inactive,
			invoices: data
		};
		return this.postCall(body, this.env.getEndPoints().archiveInvoicesEnd);
	}

	restorePOs(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().restorePOsEnd);
	}

	archiveContractors(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().archiveContractorsEnd);
	}
	restoreContractors(data) {
		const body = data;
		return this.postCall(body, this.env.getEndPoints().restoreContractorsEnd);
	}

	archiveInvoiceReconciliations(data) {
		const body = data;
		return this.putCall(body, this.env.getEndPoints().archiveInvoiceReconciliationsEnd);
	}

	restoreInvoiceReconciliations(data) {
		const body = data;
		return this.putCall(body, this.env.getEndPoints().restoreInvoiceReconciliationsEnd);
	}

	sendSupInvoice(invoiceData) {
		const body = invoiceData;
		// const self = this;
		// const bodyString = body;
		// const headers = new Headers({
		// 	'Content-Type': 'application/json',
		// 	'x-access-token': self.token,
		// 	'Authorization': 'Bearer ' + self.token
		// });
		// const options = new RequestOptions({ headers: headers });
		// console.log('PUT BODY: ' + bodyString);
		// return this.http.put(this.env.apiRoot + this.env.getEndPoints().invoiceSupSubmitEnd.path, bodyString, options).pipe(map(res => res),
		// 	catchError(error => this.errorHandlerForSendPOAndInvoice(error, this.env.apiRoot + this.env.endpoints.invoiceSupSubmitEnd.path, bodyString)),)

		return this.putCall(body, this.env.getEndPoints().invoiceSupSubmitEnd);
	}

	exportToCSV(filename, header, data) {
		console.log('export data as csv');
		const filteredHeader = header.filter( col => col.view );
		const r0 = [];
		filteredHeader.forEach(col => {
			r0.push(col.name);
		});
		const rows = [];
		rows.push(r0);

		data.forEach(rowObj => {
			const row = [];
			filteredHeader.forEach(col => {
				let val = '';
				const objnames = col.prop.split('.');
				const rowObject = rowObj[objnames[0]];
				if (objnames.length > 1 && rowObject) {
					if (_.isArray(rowObject) && rowObject.length > 0) {
						val = rowObj[objnames[0]][0][objnames[1]];
					} else {
						val = rowObj[objnames[0]][objnames[1]];
					}
				} else {
					val = rowObj[col.prop];
				}
				if (val) {
					val = val.toString().replace(/,/gi, ';');
					val = val.replace(/\r\n|\n|\r/gi, ' ');
				}
				row.push(val);
			});
			rows.push(row);
		});

		let csvContent = '';
		rows.forEach(function (rowArray) {
			const row = rowArray.join(',');
			csvContent += row + '\r\n';
		});

		this.saveToCSV(filename, csvContent);
	}

	saveToCSV(filename, csvContent) {
		const blob = new Blob([csvContent], {
			type: 'text/csv;charset=utf-8;'
		});
		if (filename.indexOf('.') < 0) {
			filename += '.csv';
		}
		if (window.navigator.msSaveOrOpenBlob) {
			const retVal = window.navigator.msSaveBlob(blob, filename);
			if (!retVal) {
				this.saveBlob(blob, filename);
			}
		} else {
			this.saveBlob(blob, filename);
		}
	}

	saveBlob(blob, filename) {
		// create a hidden link for download
		const link = document.createElement('a');
		link.setAttribute('href', window.URL.createObjectURL(blob));
		link.setAttribute('download', filename);
		link.style.visibility = 'hidden';
		document.body.appendChild(link); // Required for FF
		link.click(); // This will download the data file named filename.
		document.body.removeChild(link);
	}

	getUserConfigs() {
		return this.getCall(this.env.getEndPoints().userConfigsEnd);
	}

	postUserConfigs(data) {
		return this.postCall(data, this.env.getEndPoints().userConfigsEnd);
	}

	getCountryCodes() {
		return this.getCall(this.env.getEndPoints().countryCodesEnd);
	}

	getCountries() {
		return this.getCall(this.env.getEndPoints().countriesEnd);
	}

	getDivisionCodes() {
		return this.getCall(this.env.getEndPoints().divisionCodesEnd);
	}

	getSuppliers() {
		return this.getCall(this.env.getEndPoints().suppliersEnd);
	}

	forceReconciliation(data) {
		data.reconciliationstatus = 'Forced Pass';
		return this.postCall(data, this.env.getEndPoints().forceReconciliation);
	}

	rejectSupplierInvoices(data) {
		return this.postCall(data, this.env.getEndPoints().rejectSupplierInvoices);
	}

	getRejectReasons() {
		return this.getCall(this.env.getEndPoints().getRejectReasons);
	}

	getInvoiceReports(data) {
		return this.postCall(data, this.env.getEndPoints().invoiceReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getLiabilityReports(data) {
		return this.postCall(data, this.env.getEndPoints().liabilityReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getTimesheetReports(data) {
		return this.postCall(data, this.env.getEndPoints().timesheetReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getPurchaseOrderReports(data) {
		return this.postCall(data, this.env.getEndPoints().poReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getContractorReports(data) {
		return this.postCall(data, this.env.getEndPoints().contractorReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getActiveContractorReports(data) {
		return this.postCall(data, this.env.getEndPoints().activeContractorReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getContractorNoTSReports(data) {
		return this.postCall(data, this.env.getEndPoints().contractorNoTSReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	getContractorMissTSReports(data) {
		return this.postCall(data, this.env.getEndPoints().contractorMissTSReports, undefined, this.env.getReportRoot(), {responseType: 'text'});
	}

	/**
	 *  this method is same as removeAuth() from user.service.
	 * due to circular dependency issue, duplicating code in here to be called when API returns "Failed to validate token"
	 */
	logoutAndRedirectToLogin() {
		this.cookieService.deleteAll('/');
		this.cookies = this.cookieService.getAll();
		this.dataService.clearData();
		console.log('REMOVE AUTH', this.cookies);
		if (this.dataService.isLoggingInWithSSO) {
			this.dataService.isLoggingInWithSSO = false;
			console.log('REMOVE SSO AUTH');
			let ssoLogoutWindow;
			if (this.configService.username.trim().toLowerCase().endsWith('ibm.com')) {
				ssoLogoutWindow = window.open(this.env.getLogoutUrl());
			}else{
				ssoLogoutWindow = window.open(this.env.getIbmid_Logout_url());
			}
			setTimeout(() => {
				ssoLogoutWindow.close();
			}, 4000);
		}
	}

	refreshToken() {
		const body = {
			refreshToken: this.dataService.refreshToken
		};
		return this.postCall(body, this.env.getEndPoints().userRefreshTokenEnd);
	}

	// private methods. if gets unauthorzied 401, it shoudld get a new token from backend and try again.
	private errorHandler(err: any, url: string, method: string, body?) {
		if (err.status === 401 && this.dataService.refreshToken) {
			return this.refreshToken().pipe(
				switchMap(data => {
					this.token = data['accessToken'];
					this.cookieService.set('token', this.token, 99999999999999999, '/');
					let headers = new HttpHeaders({
						'Content-Type': 'application/json'
					});
					if (this.token) {
						headers = headers.append('x-access-token', this.token);
						headers = headers.append('Authorization', 'Bearer ' + this.token);
					}
					const options = { headers };
					if (method.toUpperCase() === 'POST') {
						return this.http.post(url, body, options);
					} else if (method.toUpperCase() === 'PUT') {
						return this.http.put(url, body, options);
					} else if (method.toUpperCase() === 'GET') {
						return this.http.get(url, options);
					} else if (method.toUpperCase() === 'DELETE') {
						return this.http.delete(url, options);
					}
				}));
		}
		return observableThrowError(err);
	}

	// private errorHandler(err: any, url: string, method: string, body?) {
	// 	if (err.status === 401 && this.dataService.refreshToken) {
	// 		return this.refreshToken()
	// 		.switchMap(data => {
	// 				// response of API /token is not in the standard json format
	// 				this.token = data.accessToken;
	// 				this.cookieService.set('token', this.token, 99999999999999999, '/');
	// 				let headers = new HttpHeaders({
	// 					'Content-Type': 'application/json'
	// 				});
	// 				if (this.token) {
	// 					headers = headers.append('x-access-token', this.token);
	// 					headers = headers.append('Authorization', 'Bearer ' + this.token);
	// 				}

	// 				const options = { headers };
	// 				if (method.toUpperCase() === 'POST') {
	// 					return this.http.post(url, body, options);
	// 				} else if (method.toUpperCase() === 'PUT') {
	// 					return this.http.put(url, body, options);
	// 				} else if (method.toUpperCase() === 'GET') {
	// 					return this.http.get(url, options);
	// 				} else if (method.toUpperCase() === 'DELETE') {
	// 					const deleteOptions = {
	// 						headers: headers,
	// 						body: body
	// 					};
	// 					return this.http.delete(url, deleteOptions);
	// 				}
	// 			});
	// 	}
	// 	return observableThrowError(err);
	// }

	// private errorHandlerForSendPOAndInvoice(err: any, url: string, body?: string) {
	// 	if (err.status === 401 && this.dataService.refreshToken) {
	// 		return this.refreshToken()
	// 			.switchMap(data => {
	// 				const successData = data.json();
	// 				this.token = successData.accessToken;
	// 				this.cookieService.set('token', successData.accessToken, 99999999999999999, '/');
	// 				const headers = new Headers({
	// 					'Content-Type': 'application/json',
	// 					'x-access-token': successData.accessToken,
	// 					'Authorization': 'Bearer ' + successData.accessToken
	// 				});
	// 				const options = new RequestOptions({ headers: headers });
	// 				return this.http.put(url, body, options).pipe(map(res => res));
	// 			});
	// 	}
	// 	return observableThrowError(err);
	// }

	// private errorHandlerForPostDoc(err: any, url: string, body?: any) {
	// 	if (err.status === 401 && this.dataService.refreshToken) {
	// 		return this.refreshToken()
	// 			.switchMap(data => {
	// 				const successData = data.json();
	// 				this.token = successData.accessToken;
	// 				this.cookieService.set('token', successData.accessToken, 99999999999999999, '/');
	// 				const headers = new Headers({
	// 					'x-access-token': successData.accessToken,
	// 					'Authorization': 'Bearer ' + successData.accessToken
	// 				});
	// 				const options = new RequestOptions({ headers: headers });
	// 				return this.http.post(url, body, options).pipe(map(res => res));
	// 			});
	// 	}
	// 	return observableThrowError(err);
	// }

	private errorHandlerForGetDoc(err: any, url: string) {
		if (err.status === 401 && this.dataService.refreshToken) {
			return this.refreshToken().pipe(
				switchMap(data => {
					this.token = data['accessToken'];
					this.cookieService.set('token', this.token, 99999999999999999, '/');

					const headers = new HttpHeaders({
						'x-access-token': this.token,
						'Authorization': 'Bearer ' + this.token
					});

					return this.http.get(url, {headers, responseType: 'arraybuffer'});
				}));
		}
		return observableThrowError(err);
	}


	loadAllSuppliers(spinner = true) {
		if (spinner) {
			this.displayService.startLoading();
		}
		this.getSuppliers().subscribe((res) => {
			console.log('LOAD ALL DIVISION CODES: ', res);
			if (spinner) {
				this.displayService.endLoading();
			}
			const successData = this.getSuccessData(res);
			this.dataService.updateSuppliers(successData);
		}, (err) => {
			console.log('LOAD ALL SUPPLIERS ERROR' + err);
			if (spinner) {
				this.displayService.endLoading();
				this.handleAPIError('Load All Suppliers', err);
			}
		});
	}

	getDashBoard() {
		return this.getCall(this.env.getEndPoints().dashboard);
	}

	getReleaseNotes(): Observable<any> {
		return this.getCall(this.env.getEndPoints().releaseNotes);
	}

	getNonBillableCodes(): Observable<any> {
		return this.getCall(this.env.getEndPoints().nonbillableCodes);
	}

	getAnnouncement(): Observable<any> {
		return this.getCall(this.env.getEndPoints().announcements);
	}

	getLoginHelp():Observable<any> {
		return this.getCall(this.env.getEndPoints().loginHelp);
	}

	addUserSettingsToBody(body){
		const userCountries = this.getUserCountries();
		if (userCountries !== '' && body[this.configService.countryCodeProp] === undefined) {
			body[this.configService.countryCodeProp] = userCountries;
		}
		const userDivisions = this.getUserDivisions();
		if (userDivisions !== '' && body['divisioncode'] === undefined) {
			body['divisioncode'] = userDivisions;
		}
		const userCostCenters = this.getUserCostCenters();
		if (userDivisions !== '' && body['costcenter'] === undefined) {
			body['costcenter'] = userCostCenters;
		}
	}
}
